import { Grid, Typography } from '@mui/material';

import { riskyPluralize } from '@/utils/strings/riskyPluralize';

import {
  MESSAGE_LIMIT,
  MESSAGE_LIMIT_WARNING_THRESHOLD,
} from '../AssistantConversation';

interface Props {
  currentMessageCount: number;
}

export const AssistantConversationLimitText = ({
  currentMessageCount,
}: Props) => {
  const variant = 'caption';
  const color = 'textDisabled';

  const isOverLimit = currentMessageCount >= MESSAGE_LIMIT;
  const isApproachingLimit =
    currentMessageCount >= MESSAGE_LIMIT_WARNING_THRESHOLD;

  const messagesLeft = MESSAGE_LIMIT - currentMessageCount;

  return (
    <Grid
      width={'100%'}
      alignItems={'center'}
      display={'flex'}
      justifyContent={'center'}
    >
      {isOverLimit && (
        <Typography variant={variant} color={color}>
          You have reached the message limit of {MESSAGE_LIMIT} messages
        </Typography>
      )}
      {isApproachingLimit && !isOverLimit && (
        <Typography variant={variant} color={color}>
          You are approaching the message limit of {MESSAGE_LIMIT} messages, you
          have {messagesLeft} {riskyPluralize('message', messagesLeft)} left
        </Typography>
      )}
    </Grid>
  );
};
